import React, { useContext } from 'react';
import { ProfileContext } from '@loyalup/core';
import { Sidebar } from '@loyalup/ui';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ClientsIcon } from 'icons/menu-clients.svg';
import { ReactComponent as SettingsIcon } from 'icons/menu-settings.svg';
import { ReactComponent as CampaignsIcon } from 'icons/menu-campaigns.svg';
import { ReactComponent as CardIcon } from 'icons/card.svg';
import { ReactComponent as DeliveryIcon } from 'icons/delivery.svg';
import { ReactComponent as BasketIcon } from 'icons/basket.svg';
import { ReactComponent as LoyaltyIcon } from 'icons/loyalty.svg';
import { ReactComponent as StatsIcon } from 'icons/stats.svg';

const { MenuItem, MenuGroup } = Sidebar;

const SidebarMenu = () => {
  const [t] = useTranslation();
  const { permissions } = useContext(ProfileContext);

  const {
    managePassDesigns,
    manageCompanyClientOrders,
    manageCompanyClients,
    manageCompanyCampaigns,
    companyAdmin,
    manageCompanyLoyalties,
    viewCompanyStats,
    manageCompanyFeedbacks = true,
  } = permissions;

  return (
    <>
      <MenuGroup icon={<ClientsIcon />} text={t('Клиенты')} root="/clients" to="/clients/list">
        {(companyAdmin || manageCompanyClients) && <MenuItem to="/clients/list" text={t('Список клиентов')} />}
        {(companyAdmin || manageCompanyFeedbacks) && <MenuItem to="/clients/feedbacks" text={t('Отзывы')} />}
      </MenuGroup>
      {(companyAdmin || manageCompanyClientOrders) && (
        <MenuItem exact to="/orders" icon={<BasketIcon />} text={t('Заказы')} />
      )}
      {(companyAdmin || manageCompanyCampaigns) && (
        <MenuGroup icon={<CampaignsIcon />} text={t('Уведомления')} root="/campaigns" to="/campaigns/list">
          <MenuItem to="/campaigns/list" text={t('Рассылки')} />
          <MenuItem to="/campaigns/triggers" text={t('Триггерные')} />
          <MenuItem to="/campaigns/geo" text={t('Гео-уведомления')} />
        </MenuGroup>
      )}
      {(companyAdmin || managePassDesigns) && <MenuItem to="/designer" icon={<CardIcon />} text={t('Дизайнер карт')} />}
      <MenuGroup icon={<DeliveryIcon />} text={t('Доставка карт')} root="/delivery" to="/delivery/selfsignup">
        <MenuItem to="/delivery/selfsignup" text={t('Анкета')} />
        <MenuItem to="/delivery/email" text={t('Е-мейл')} />
        <MenuItem to="/delivery/sms" text={t('SMS')} />
      </MenuGroup>
      {(companyAdmin || manageCompanyLoyalties) && (
        <MenuItem exact to="/loyalty/programs" icon={<LoyaltyIcon />} text={t('Программа лояльности')} />
      )}
      {(companyAdmin || viewCompanyStats) && <MenuItem exact to="/stats" icon={<StatsIcon />} text={t('Статистика')} />}
      <MenuGroup icon={<SettingsIcon />} text={t('Настройки')} root="/settings" to="/settings/me">
        <MenuItem to="/settings/me" text={t('Мой Профиль')} />
        {companyAdmin && <MenuItem to="/settings/company" text={t('Компания')} />}
        <MenuItem to="/settings/integrations" text={t('Интеграции')} />
      </MenuGroup>
    </>
  );
};

export default SidebarMenu;
